import { fork } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import { GET_FAVOURITE_LOCATIONS } from 'app/constants';
import loadLocations from './loadLocations';

export default function* watchLoadLocations() {
  yield fork(takeLatest, GET_FAVOURITE_LOCATIONS, loadLocations);
}
